import { api } from '../Controllers/api'
import jwtDecode from 'jwt-decode'

const updateUser = user => {
  return {
    type: 'UPDATE_USER',
    payload: { user }
  }
}

const logout = () => {
  return {
    type: 'LOGOUT_USER'
  }
}

const login = () => {
  return {
    type: 'LOGIN_USER',
    payload: { loggedIn: true, loading: false }
  }
}

const getUserData = () => {
  const auth = localStorage.getItem('auth')
  const user = jwtDecode(auth)
  if (user) {
    return dispatch => {
      dispatch(updateUser(user))
    }
  }
}

const logoutUser = () => {
  return dispatch => {
    const clearData = () => {
      localStorage.removeItem('userToken')
      localStorage.removeItem('auth')
      dispatch(logout())
    }
    api
      .get('/weblogin/clearcookie')
      .then(response => {
        clearData()
      })
      .catch(err => {
        clearData()
      })
  }
}

const checkLogin = successCallback => {
  return dispatch => {
    api
      .get('weblogin/readcookie')
      .then(({ data }) => {
        if (data.loggedIn === true) {
          dispatch(getUserData())
          dispatch(login())
          if (successCallback) {
            successCallback()
          }
        } else {
          dispatch(logout())
          dispatch(logoutUser())
        }
      })
      .catch(() => {
        dispatch(logout())
        dispatch(logoutUser())
      })
  }
}

const loginUser = user => {
  return dispatch => {
    dispatch(login())
    dispatch(updateUser(user))
  }
}

export { getUserData, logoutUser, loginUser, checkLogin }
